
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 4.16.2
 * Query Engine version: 4bc8b6e1b66cb932731fb1bdbbc550d1e010de81
 */
Prisma.prismaVersion = {
  client: "4.16.2",
  engine: "4bc8b6e1b66cb932731fb1bdbbc550d1e010de81"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  throw new Error(`Extensions.getExtensionContext is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.defineExtension = () => {
  throw new Error(`Extensions.defineExtension is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  firstName: 'firstName',
  password: 'password',
  lastName: 'lastName',
  email: 'email',
  role: 'role',
  DBStatus: 'DBStatus'
};

exports.Prisma.PlayerScalarFieldEnum = {
  id: 'id'
};

exports.Prisma.SeasonPlayerScalarFieldEnum = {
  id: 'id',
  firstName: 'firstName',
  lastName: 'lastName',
  height: 'height',
  birthday: 'birthday',
  weight: 'weight',
  hand: 'hand',
  racketPosture: 'racketPosture',
  playerId: 'playerId',
  seasonId: 'seasonId',
  seasonTeamId: 'seasonTeamId',
  role: 'role',
  nationality: 'nationality',
  nationalitySecondary: 'nationalitySecondary',
  DBStatus: 'DBStatus',
  outfitterId: 'outfitterId',
  outfitterLink: 'outfitterLink',
  imageUrl: 'imageUrl',
  actionImageUrl: 'actionImageUrl',
  cardImageUrl: 'cardImageUrl',
  instagramLink: 'instagramLink',
  youtubeLink: 'youtubeLink',
  websiteLink: 'websiteLink',
  tiktokLink: 'tiktokLink',
  facebookLink: 'facebookLink',
  rank: 'rank',
  worldRank: 'worldRank',
  wttId: 'wttId',
  qttrValue: 'qttrValue',
  qttrKey: 'qttrKey'
};

exports.Prisma.LeaguePlayerScalarFieldEnum = {
  id: 'id',
  seasonPlayerId: 'seasonPlayerId',
  leagueTeamId: 'leagueTeamId',
  league: 'league',
  leagueId: 'leagueId',
  rank: 'rank',
  gameWins: 'gameWins',
  gameLosses: 'gameLosses',
  gameDifference: 'gameDifference',
  ballWins: 'ballWins',
  ballLosses: 'ballLosses',
  setWins: 'setWins',
  setLosses: 'setLosses',
  DBStatus: 'DBStatus'
};

exports.Prisma.TeamScalarFieldEnum = {
  id: 'id'
};

exports.Prisma.SeasonTeamScalarFieldEnum = {
  id: 'id',
  isActive: 'isActive',
  name: 'name',
  place: 'place',
  adressPlace: 'adressPlace',
  shortname: 'shortname',
  adress: 'adress',
  zipCode: 'zipCode',
  phoneNumber: 'phoneNumber',
  email: 'email',
  seasonId: 'seasonId',
  teamId: 'teamId',
  DBStatus: 'DBStatus',
  imageUrl: 'imageUrl',
  teamImageUrl: 'teamImageUrl',
  logoPngUrl: 'logoPngUrl',
  logoSvgUrl: 'logoSvgUrl',
  teaserImageUrl: 'teaserImageUrl',
  instagramLink: 'instagramLink',
  youtubeLink: 'youtubeLink',
  websiteLink: 'websiteLink',
  tiktokLink: 'tiktokLink',
  facebookLink: 'facebookLink',
  ticketshopLink: 'ticketshopLink',
  foundingYear: 'foundingYear',
  playingSince: 'playingSince',
  bundesligaTitles: 'bundesligaTitles',
  pokalTitles: 'pokalTitles',
  internationalTitles: 'internationalTitles',
  outfitterId: 'outfitterId',
  outfitterLink: 'outfitterLink',
  venueId: 'venueId'
};

exports.Prisma.LeagueTeamScalarFieldEnum = {
  id: 'id',
  seasonTeamId: 'seasonTeamId',
  league: 'league',
  leagueId: 'leagueId',
  rank: 'rank',
  plusPoints: 'plusPoints',
  minusPoints: 'minusPoints',
  matchCount: 'matchCount',
  matchWins: 'matchWins',
  matchLosses: 'matchLosses',
  gameWins: 'gameWins',
  gameLosses: 'gameLosses',
  gameDifference: 'gameDifference',
  ballWins: 'ballWins',
  ballLosses: 'ballLosses',
  setWins: 'setWins',
  setLosses: 'setLosses',
  DBStatus: 'DBStatus'
};

exports.Prisma.SeasonDoubleScalarFieldEnum = {
  id: 'id',
  seasonId: 'seasonId',
  seasonTeamId: 'seasonTeamId',
  seasonPlayerOneId: 'seasonPlayerOneId',
  seasonPlayerTwoId: 'seasonPlayerTwoId'
};

exports.Prisma.LeagueDoubleScalarFieldEnum = {
  id: 'id',
  seasonDoubleId: 'seasonDoubleId',
  leagueTeamId: 'leagueTeamId',
  leagueId: 'leagueId',
  leaguePlayerOneId: 'leaguePlayerOneId',
  leaguePlayerTwoId: 'leaguePlayerTwoId',
  rank: 'rank',
  gameWins: 'gameWins',
  gameLosses: 'gameLosses',
  gameDifference: 'gameDifference',
  ballWins: 'ballWins',
  ballLosses: 'ballLosses',
  setWins: 'setWins',
  setLosses: 'setLosses'
};

exports.Prisma.GameScalarFieldEnum = {
  id: 'id',
  matchId: 'matchId',
  homePlayerId: 'homePlayerId',
  awayPlayerId: 'awayPlayerId',
  homeDoubleId: 'homeDoubleId',
  awayDoubleId: 'awayDoubleId',
  gameState: 'gameState',
  description: 'description',
  index: 'index',
  isDouble: 'isDouble',
  DBStatus: 'DBStatus',
  homeSets: 'homeSets',
  awaySets: 'awaySets',
  homeBalls: 'homeBalls',
  awayBalls: 'awayBalls',
  set1ServerSide: 'set1ServerSide',
  set1HomeScore: 'set1HomeScore',
  set1AwayScore: 'set1AwayScore',
  set1WinnerSide: 'set1WinnerSide',
  set2ServerSide: 'set2ServerSide',
  set2HomeScore: 'set2HomeScore',
  set2AwayScore: 'set2AwayScore',
  set2WinnerSide: 'set2WinnerSide',
  set3ServerSide: 'set3ServerSide',
  set3HomeScore: 'set3HomeScore',
  set3AwayScore: 'set3AwayScore',
  set3WinnerSide: 'set3WinnerSide',
  set4ServerSide: 'set4ServerSide',
  set4HomeScore: 'set4HomeScore',
  set4AwayScore: 'set4AwayScore',
  set4WinnerSide: 'set4WinnerSide',
  set5ServerSide: 'set5ServerSide',
  set5HomeScore: 'set5HomeScore',
  set5AwayScore: 'set5AwayScore',
  set5WinnerSide: 'set5WinnerSide',
  winnerSide: 'winnerSide',
  winReason: 'winReason',
  awayTimeoutUsed: 'awayTimeoutUsed',
  homeTimeoutUsed: 'homeTimeoutUsed',
  currentSet: 'currentSet'
};

exports.Prisma.ScoringUpdatesScalarFieldEnum = {
  id: 'id',
  matchId: 'matchId',
  gameId: 'gameId',
  submissionID: 'submissionID',
  index: 'index',
  undoId: 'undoId',
  type: 'type',
  ts: 'ts',
  playerId: 'playerId',
  pointId: 'pointId',
  set: 'set',
  result: 'result',
  point: 'point',
  bwRating: 'bwRating',
  isAcePoint: 'isAcePoint',
  isServerErrorPoint: 'isServerErrorPoint',
  isLuckyShot: 'isLuckyShot',
  isNetRoller: 'isNetRoller',
  isEdgeBall: 'isEdgeBall',
  homePlayerId: 'homePlayerId',
  awayPlayerId: 'awayPlayerId',
  appVersion: 'appVersion'
};

exports.Prisma.CardScalarFieldEnum = {
  id: 'id',
  matchId: 'matchId',
  gameId: 'gameId',
  set: 'set',
  playerId: 'playerId',
  type: 'type'
};

exports.Prisma.MatchScalarFieldEnum = {
  id: 'id',
  homeTeamId: 'homeTeamId',
  awayTeamId: 'awayTeamId',
  timeStamp: 'timeStamp',
  gamedayId: 'gamedayId',
  matchState: 'matchState',
  league: 'league',
  leagueId: 'leagueId',
  venueId: 'venueId',
  spectators: 'spectators',
  livestreamUrl: 'livestreamUrl',
  preliminaryReportUrl: 'preliminaryReportUrl',
  ticketshopUrl: 'ticketshopUrl',
  followupReport: 'followupReport',
  description: 'description',
  DBStatus: 'DBStatus',
  homeGames: 'homeGames',
  awayGames: 'awayGames',
  homeSets: 'homeSets',
  awaySets: 'awaySets',
  homeBalls: 'homeBalls',
  awayBalls: 'awayBalls',
  isFlaggedAsBroken: 'isFlaggedAsBroken',
  updateCount: 'updateCount',
  homePlayerOneId: 'homePlayerOneId',
  homePlayerTwoId: 'homePlayerTwoId',
  homePlayerThreeId: 'homePlayerThreeId',
  homeSubstitutePlayerOneId: 'homeSubstitutePlayerOneId',
  homeSubstitutePlayerTwoId: 'homeSubstitutePlayerTwoId',
  homeSubstitutePlayerThreeId: 'homeSubstitutePlayerThreeId',
  homeTrainerId: 'homeTrainerId',
  homeSubstituteEnteredId: 'homeSubstituteEnteredId',
  homeSubstitutedPlayerId: 'homeSubstitutedPlayerId',
  homeSubstituteTwoEnteredId: 'homeSubstituteTwoEnteredId',
  homeSubstitutedTwoPlayerId: 'homeSubstitutedTwoPlayerId',
  guestPlayerOneId: 'guestPlayerOneId',
  guestPlayerTwoId: 'guestPlayerTwoId',
  guestPlayerThreeId: 'guestPlayerThreeId',
  guestSubstitutePlayerOneId: 'guestSubstitutePlayerOneId',
  guestSubstitutePlayerTwoId: 'guestSubstitutePlayerTwoId',
  guestSubstitutePlayerThreeId: 'guestSubstitutePlayerThreeId',
  guestTrainerId: 'guestTrainerId',
  guestSubstituteEnteredId: 'guestSubstituteEnteredId',
  guestSubstitutedPlayerId: 'guestSubstitutedPlayerId',
  guestSubstituteTwoEnteredId: 'guestSubstituteTwoEnteredId',
  guestSubstitutedTwoPlayerId: 'guestSubstitutedTwoPlayerId'
};

exports.Prisma.GamedayScalarFieldEnum = {
  id: 'id',
  name: 'name',
  index: 'index',
  leagueId: 'leagueId',
  league: 'league',
  type: 'type'
};

exports.Prisma.BundesLigaScalarFieldEnum = {
  id: 'id',
  seasonId: 'seasonId',
  name: 'name',
  gamedayCount: 'gamedayCount',
  status: 'status',
  gamedayDescription: 'gamedayDescription',
  playoffRoundOneName: 'playoffRoundOneName',
  playoffRoundOneDescription: 'playoffRoundOneDescription',
  playoffRoundTwoName: 'playoffRoundTwoName',
  playoffRoundTwoDescription: 'playoffRoundTwoDescription',
  winnerImageUrl: 'winnerImageUrl',
  winnerName: 'winnerName',
  articleLink: 'articleLink',
  showOnHomePage: 'showOnHomePage'
};

exports.Prisma.PokalScalarFieldEnum = {
  id: 'id',
  seasonId: 'seasonId',
  name: 'name',
  status: 'status',
  playoffRoundOneName: 'playoffRoundOneName',
  playoffRoundOneDescription: 'playoffRoundOneDescription',
  playoffRoundTwoName: 'playoffRoundTwoName',
  playoffRoundTwoDescription: 'playoffRoundTwoDescription',
  playoffRoundThreeName: 'playoffRoundThreeName',
  playoffRoundThreeDescription: 'playoffRoundThreeDescription',
  playoffRoundFourName: 'playoffRoundFourName',
  playoffRoundFourDescription: 'playoffRoundFourDescription',
  winnerImageUrl: 'winnerImageUrl',
  winnerName: 'winnerName',
  articleLink: 'articleLink',
  showOnHomePage: 'showOnHomePage'
};

exports.Prisma.SeasonScalarFieldEnum = {
  id: 'id',
  startYear: 'startYear',
  endYear: 'endYear',
  isCurrentSeason: 'isCurrentSeason'
};

exports.Prisma.VenueScalarFieldEnum = {
  id: 'id',
  name: 'name',
  adress: 'adress',
  zipCode: 'zipCode',
  place: 'place',
  geoCoordinates: 'geoCoordinates',
  website: 'website',
  DBStatus: 'DBStatus',
  imageUrl: 'imageUrl'
};

exports.Prisma.OutfitterScalarFieldEnum = {
  id: 'id',
  company: 'company',
  website: 'website'
};

exports.Prisma.DebugDataScalarFieldEnum = {
  id: 'id',
  date: 'date',
  value: 'value',
  createdAt: 'createdAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.UserRole = {
  SuperAdmin: 'SuperAdmin',
  Admin: 'Admin'
};

exports.DBStatus = {
  Active: 'Active',
  Deleted: 'Deleted'
};

exports.Hand = {
  Left: 'Left',
  Right: 'Right'
};

exports.RacketPosture = {
  Shakehand: 'Shakehand',
  Penholder: 'Penholder'
};

exports.PlayerRole = {
  Player: 'Player',
  Coach: 'Coach'
};

exports.League = {
  Bundesliga: 'Bundesliga',
  Pokal: 'Pokal'
};

exports.IsActive = {
  Yes: 'Yes',
  No: 'No'
};

exports.GameState = {
  Inactive: 'Inactive',
  Active: 'Active',
  Finished: 'Finished'
};

exports.Side = {
  Home: 'Home',
  Away: 'Away'
};

exports.GameScoringUpdateType = {
  Create: 'Create',
  SwitchDoublesGame: 'SwitchDoublesGame',
  Substitution: 'Substitution',
  SubstitutionInjury: 'SubstitutionInjury',
  Point: 'Point',
  DecrementPoint: 'DecrementPoint',
  EventGameStart: 'EventGameStart',
  EventGameEnd: 'EventGameEnd',
  EventService: 'EventService',
  EventPauseStart: 'EventPauseStart',
  EventPauseEnd: 'EventPauseEnd',
  EventTimeoutStart: 'EventTimeoutStart',
  EventTimeoutEnd: 'EventTimeoutEnd',
  EventYellowCard: 'EventYellowCard',
  EventYellowRedCard: 'EventYellowRedCard',
  EventYellowRedCard2: 'EventYellowRedCard2',
  EventRedCard: 'EventRedCard',
  EventSetStart: 'EventSetStart',
  EventSetEnd: 'EventSetEnd',
  EventAbandoned: 'EventAbandoned',
  EventInjury: 'EventInjury',
  EditGameResults: 'EditGameResults',
  EditMatchResults: 'EditMatchResults'
};

exports.CardType = {
  Yellow: 'Yellow',
  YellowRed: 'YellowRed',
  YellowRed2: 'YellowRed2',
  Red: 'Red'
};

exports.MatchState = {
  Inactive: 'Inactive',
  Active: 'Active',
  Finished: 'Finished'
};

exports.GamedayType = {
  Normal: 'Normal',
  QuarterFinals: 'QuarterFinals',
  RoundOf16: 'RoundOf16',
  SemiFinals: 'SemiFinals',
  Finals: 'Finals'
};

exports.LeagueStatus = {
  Active: 'Active',
  Inactive: 'Inactive',
  Preseason: 'Preseason'
};

exports.ShowOnHomePage = {
  Yes: 'Yes',
  No: 'No'
};

exports.Prisma.ModelName = {
  User: 'User',
  Player: 'Player',
  SeasonPlayer: 'SeasonPlayer',
  LeaguePlayer: 'LeaguePlayer',
  Team: 'Team',
  SeasonTeam: 'SeasonTeam',
  LeagueTeam: 'LeagueTeam',
  SeasonDouble: 'SeasonDouble',
  LeagueDouble: 'LeagueDouble',
  Game: 'Game',
  ScoringUpdates: 'ScoringUpdates',
  Card: 'Card',
  Match: 'Match',
  Gameday: 'Gameday',
  BundesLiga: 'BundesLiga',
  Pokal: 'Pokal',
  Season: 'Season',
  Venue: 'Venue',
  Outfitter: 'Outfitter',
  DebugData: 'DebugData'
};

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
